import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { useEffect } from 'react';
import { SelectChildDto } from '@/shared/interfaces';
import { SexEnum } from '@/shared/enums';
import { Providers } from '@/shared/Providers';
import { PfaPhysiotherapyFlow } from '@/features/pfaPhysiotherapy/app/PfaPhysiotherapyFlow';

export type PfaPhysiotherapyAppProps = {
    parentUid: string;
    adolescentMinAge: number;
    adultMinAge: number;
    isAdolescentEnabled: boolean;
    parentFirstName: string;
    parentGender: SexEnum;
    children: SelectChildDto[];
    childTerms: string;
    showPatientSelection: boolean;
};

export const PfaPhysiotherapyApp = (
    containerQuery: string,
    props: PfaPhysiotherapyAppProps,
) => {
    const container = document.querySelector(containerQuery);
    if (!container) return;

    createRoot(container).render(
        <Providers>
            <App {...props} />
        </Providers>,
    );
};

function App(props: PfaPhysiotherapyAppProps) {
    useEffect(() => {
        document.getElementById('profile-spinner')?.remove();
    }, []);

    return (
        <BrowserRouter>
            <PfaPhysiotherapyFlow appProps={props} />
        </BrowserRouter>
    );
}
